import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import { ActivatedRoute, Route } from '@angular/router';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-margin-trading-summary',
  templateUrl: './margin-trading-summary.component.html',
  styleUrls: ['./margin-trading-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarginTradingSummaryComponent implements OnInit {
  ledgerSummary = null;
  summaryLoading = false;
  toDate = new Date();
  currentUser;
  fundId = new FormControl({ customerCode: '', customerName: '' }, []);
  // balanceInProgress: boolean;
  balanceInfo;
  investerCode;
  marginTradeDetails;
  availablebalance;
  constructor(private cdRef: ChangeDetectorRef, private account: AccountService, private activatedRoute: ActivatedRoute) {}

  async ngOnInit() {
    this.currentUser = await this.account.currentUserAsync();
    this.marginTradeDetails = (localStorage['marginTradeDetails'] && JSON.parse(localStorage['marginTradeDetails'])) || [];
    this.currentUser.marginTradeDetails.forEach((jontAcc, index) => (jontAcc['index'] = index));
    // console.log(this.currentUser);

    this.activatedRoute.params.subscribe((params) => {
      this.investerCode = params['investorCode'];
      console.log('investorCode', this.investerCode);
      this.fundId.setValue({ customerCode: params['investorCode'], customerName: params['investorCode'] });
      this.loadPageData(params['investorCode']);
    });
    this.fundId.valueChanges.subscribe((val) => {
      console.log(val);
      if (val) {
        this.loadPageData(val.customerCode);
      }
    });
    this.cdRef.detectChanges();
  }

  async loadPageData(investorCode) {
    let date = new Date();

    try {
      this.summaryLoading = true;
      this.cdRef.detectChanges();

      let fromDate = moment(date.setDate(date.getDate() - 7)).format('YYYY-MM-DD');
      let toDate = moment(this.toDate).format('YYYY-MM-DD');
      this.ledgerSummary = await this.account.getLedgerSummary(fromDate, toDate, investorCode);
      this.summaryLoading = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.ledgerSummary = [];
      this.summaryLoading = false;

      console.log(e);
    }
    this.availablebalance = this.printBalane(investorCode);
    this.cdRef.detectChanges();
  }

  printBalane = (code) => {
    let details = this.marginTradeDetails.find((row) => row.code === code);
    return details?.total || 0;
  };
}
